import { render } from "./action.vue?vue&type=template&id=b5189dac&ts=true"
import script from "./action.vue?vue&type=script&lang=ts"
export * from "./action.vue?vue&type=script&lang=ts"

import exportComponent from "/mobefind/admin/auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__